module.exports = __webpack_public_path__ + "img/logo-mini.83c414f4.jpg";